import PopupClosed from './PopupClosed';
export default PopupClosed;
